import { BasicSectionContainer } from 'screens/style';
import styled from 'styled-components';

export const AuthCallbackGoogleContainer = styled(BasicSectionContainer)`
  width: 100%;
  min-height: 667px;
  display: flex;
  justify-content: center;
  align-content: center;

  .innerContainer {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  

`;